<template>
  <transition name="fade">
    <div class="popup-modal" v-if="isVisible" @click.self="close">
      <div class="window" :style="windowStyle">
        <div class="popup-header" v-if="$slots.header">
          <slot name="header" />
        </div>
        <div class="content">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    maxWidth: {
      type: [Number, String],
      default: 680,
    },
  },
  data: () => ({
    isVisible: false,
  }),
  computed: {
    windowStyle() {
      if (typeof this.maxWidth === "number") {
        return { maxWidth: this.maxWidth + "px" };
      }
      return { maxWidth: this.maxWidth };
    },
  },
  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
  },
};
</script>
<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  z-index: 999;
}

.window {
  position: relative; /* обязательно */
  overflow: auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
  margin-left: auto;
  margin-right: auto;
  max-height: calc(100vh - 2rem); /* НЕ больше экрана */
  overflow-y: auto; /* автопрокрутка */
}
.popup-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
  padding: 0.5rem 0;
  border: none;
}

.content {
  overflow-y: auto;
  padding: 1rem;
}
</style>
